import {
  Image,
  Container,
  Row,
  Col,
  Form,
  InputGroup,
  Card,
  Button,
} from "react-bootstrap";
import React, { useState, useEffect } from "react";
import { toPng } from "html-to-image";

import imgBinanceLogo from "./assets/binance/logo.png";
import imgBinanceQR from "./assets/binance/qr.png";

function Space() {
  return "\u00A0";
}

const TRADING_PLATFORM = ["Binance", "Kraken (Unavailable)", "Kucoin (Unavailable)"];

const TRADING_PAIRS = [
  "ETHUSDT Perpetual",
  "BTCUSDT Perpetual",
  "PEPEUSDT Perpetual",
];

const generateRandomReferralBinance = () => {
  const min = 10000000; // Minimum 8-digit number
  const max = 99999999; // Maximum 8-digit number
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

const downloadDivAsPng = async (divId) => {
  const node = document.getElementById(divId);
  const dataUrl = await toPng(node);
  const link = document.createElement("a");
  link.href = dataUrl;
  link.download = "div-image.png";
  link.click();
};

const userLocale = navigator.language || "en-US";

function LeverageComponent() {
  const [tradingPlatform, setTradingPlatform] = useState(TRADING_PLATFORM[0]);

  const [deltaPrice, setDeltaPrice] = useState(0);
  const [entryPrice, setEntryPrice] = useState(1000.0);
  const [lastPrice, setLastPrice] = useState(1500.0);
  const [referralCode, setReferralCode] = useState(
    generateRandomReferralBinance()
  );
  const [percent, setPercent] = useState(156.2);
  const [leverageMultiplier, setLeverageMultiplier] = useState(50);
  const [isLong, setIsLong] = useState(true);
  const [tradingPair, setTradingPair] = useState("ETHUSDT Perpetual");

  useEffect(() => {
    const newPercent =
      (leverageMultiplier * 100 * (lastPrice - entryPrice)) / entryPrice;
    setPercent(newPercent);

    setDeltaPrice((isLong?1:-1) * (lastPrice-entryPrice));
  }, [entryPrice, lastPrice, isLong, leverageMultiplier]);


  return (
    <>
      <Container style={{ textAlign: "center", fontFamily: "BinanceMedium" }}>
        <Row style={{ margin: "50px" }}>
          <h1 style={{ fontFamily: "BinanceBold" }}>Crypto Clout PRO</h1>
          <p
            style={{
              fontFamily: "BinanceRegular",
              marginTop: "00px",
              fontSize: "20px",
            }}
          >
            Increase your <strong>🚀crypto clout</strong> with this handy tool!
            🔥
          </p>
        </Row>
        <hr style={{ marginBottom: "30px" }} />
        <Row>
          <Col md={{ span: 3 }}>
            <Container style={{ textAlign: "left" }}>
              <Row>
                <Col xs={{ span: 12 }}>
                  <Form.Label>Trading Platform</Form.Label>
                  <Form.Select
                    onChange={(e) => {
                      setTradingPlatform(e.target.value);
                    }}
                    value={tradingPlatform}
                  >
                    {TRADING_PLATFORM.map((pair, index) => (
                      <option key={index} value={pair}>
                        {pair}
                      </option>
                    ))}
                  </Form.Select>
                </Col>

                <hr style={{ marginTop: "40px", marginBottom: "40px" }} />
                <Col xs={{ span: 12 }}>
                  <Form.Label>Trading Pair</Form.Label>
                  <Form.Select
                    onChange={(e) => {
                      setTradingPair(e.target.value);
                      console.log(e.target.value);
                    }}
                    value={tradingPair}
                  >
                    {TRADING_PAIRS.map((pair, index) => (
                      <option key={index} value={pair}>
                        {pair}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
                <hr style={{ marginTop: "40px", marginBottom: "40px" }} />

                <Col xs={{ span: 12 }}>
                  <Form.Label>
                    Leverage:
                    <br />
                    <span
                      style={{
                        fontSize: "40px",
                        color: isLong ? "green" : "red",
                      }}
                    >
                      {leverageMultiplier}x ({isLong ? "Long" : "Short"})
                    </span>
                  </Form.Label>
                  <Form.Range
                    min="1"
                    max="500"
                    step="1"
                    onChange={(e) => {
                      setLeverageMultiplier(e.target.value);
                    }}
                  />
                </Col>

                <span>
                  <Space />
                </span>
                <Col xs={{ span: 12 }}>
                  <Form.Select
                    onChange={(e) => {
                      setIsLong(e.target.value === "long");
                      console.log(e.target.value);
                    }}
                    value={isLong ? "long" : "short"}
                  >
                    <option value="short">Short</option>
                    <option value="long">Long</option>
                  </Form.Select>
                </Col>

                <hr style={{ marginTop: "40px", marginBottom: "40px" }} />

                <Col xs={{ span: 12 }}>
                  <Form.Label>Price</Form.Label>
                  <InputGroup size="lg" className="mb-3">
                    <InputGroup.Text id="inputGroup-sizing-default">
                      Entry $
                    </InputGroup.Text>
                    <Form.Control
                      value={entryPrice}
                      type="number"
                      aria-label="Default"
                      aria-describedby="inputGroup-sizing-default"
                      onChange={(e) => {
                        setEntryPrice(Number(e.target.value));
                      }}
                    />
                  </InputGroup>
                </Col>

                <Col xs={{ span: 12 }}>
                  <InputGroup size="lg" className="mb-3">
                    <InputGroup.Text id="inputGroup-sizing-default">
                      Last $
                    </InputGroup.Text>
                    <Form.Control
                      value={lastPrice}
                      type="number"
                      aria-label="Default"
                      aria-describedby="inputGroup-sizing-default"
                      onChange={(e) => {
                        setLastPrice(Number(e.target.value));
                      }}
                    />
                  </InputGroup>
                </Col>
                <p style={{ fontSize: "20px" }}>
                  $
                  {lastPrice.toLocaleString(userLocale, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}{" "}
                  - $
                  {entryPrice.toLocaleString(userLocale, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                  <br />={" "}
                  <span
                    style={{
                      color: deltaPrice > 0 ? "green" : "red",
                    }}
                  >
                    $
                    {(deltaPrice).toLocaleString(userLocale, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </span>
                </p>
              </Row>
            </Container>
          </Col>

          <Col md={{ span: 9 }}>
            <div id="my-div">
              <Container style={binanceContainer}>
                <Row>
                  <Image
                    src={imgBinanceLogo}
                    style={{
                      width: "170px",
                      marginBottom: "27px",
                      marginLeft: "-25px",
                    }}
                  />
                </Row>

                <Row>
                  <p style={binanceLongInfo}>
                    <span style={{ color: isLong ? "#36b982" : "#B7586C" }}>
                      {isLong ? "LONG" : "SHORT"}
                    </span>
                    <Space />
                    <Space />
                    <Space />|<Space />
                    <Space />
                    <Space />
                    {leverageMultiplier}x<Space />
                    <Space />
                    <Space />|<Space />
                    <Space />
                    <Space />
                    {tradingPair}
                  </p>
                  <p style={{...binanceBigPercent, color:( deltaPrice>0?"#36b982" : "#B7586C")}}>
                    {deltaPrice>0 ? "+" : "-"}{" "}
                    {percent.toLocaleString(userLocale, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    %
                  </p>
                  <span
                    style={{ fontFamily: "BinanceRegular", fontSize: "32px" }}
                  >
                    <div style={{ ...binanceEntryHeader, float: "left" }}>
                      <p>Entry Price</p>{" "}
                      <p style={{ marginTop: "-3px" }}>Last Price</p>{" "}
                    </div>
                    <div
                      style={{
                        ...binanceEntryNumber,
                        float: "left",
                        marginLeft: "30px",
                      }}
                    >
                      <p>{entryPrice.toFixed(2)}</p>
                      <p style={{ marginTop: "-3px" }}>
                        {lastPrice.toFixed(2)}
                      </p>
                    </div>

                    <p style={{ clear: "both" }}></p>
                  </span>
                </Row>

                <Row>
                  <div style={{ paddingTop: "10px" }}>
                    <Image src={imgBinanceQR} />
                    <div
                      style={{
                        position: "relative",
                        top: "-74px",
                        left: "95px",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "15px",
                          color: "#8A8F96",
                          lineHeight: "0",
                        }}
                      >
                        Referral Code
                      </p>
                      <p
                        style={{
                          fontSize: "36px",
                          color: "white",
                          fontFamily: "BinanceBold",
                          lineHeight: "1em",
                        }}
                      >
                        {referralCode}
                      </p>
                      <p
                        style={{
                          fontSize: "15px",
                          color: "#B6A379",
                          lineHeight: "0",
                        }}
                      >
                        Get the Binance App
                      </p>
                    </div>
                  </div>
                </Row>
              </Container>
            </div>

            <div style={{ textAlign: "left", marginTop: "10px" }}>
              <Button size="lg" onClick={() => downloadDivAsPng("my-div")}>
                📥 Download as PNG
              </Button>
            </div>
          </Col>
        </Row>

        <hr />
        <Row style={{ textAlign: "center" }}>
          <p>
            by{" "}
            <a href="https://twitter.com/eddietree" target="_blank">
              eddie
            </a>
          </p>
        </Row>
      </Container>
    </>
  );
}

const binanceContainer = {
  backgroundColor: "black",
  padding: "60px",
  fontFamily: "BinanceRegular",
  textAlign: "left",
};
const binanceLongInfo = { fontSize: "20px" };
const binanceBigPercent = {
  fontSize: "60px",
  color: "#36b982",
  fontFamily: "BinanceBold",
  lineHeight: "1em",
};
const binanceEntryHeader = { color: "#8A8F96" };
const binanceEntryNumber = { color: "#CBAE51" };

export default LeverageComponent;
